import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { ProviderState } from '../stores/providers';
import { ProviderApi, SystemApi, ProductApi } from '../stores/apiMethods';

import { TextInput, Selectize, DadataInput } from '../forms/FormItems';
import { ButtonSelectGroup } from '../shared/FormElements';
import { TableReportPage } from './PageTemplates';
import { AddButton, CreateButton, ExpandIconButton, ItemNewHeader, RemoveIconButton } from '../shared/PageComponents';
import { WorkDaysBlock } from '../shared/WorkDaysComponents';
import { AddPhoneIcon, PayReceiptIcon } from '../images/icons';

import { toSelectList, getRubs, getVATList } from '../functions';
import { confirmState } from '../stores/common';

class ProvidersPage extends Component {
	constructor(props) {
		super(props);
		this.store = new ProviderState();
	}

	componentDidMount() {
		this.getData();

		SystemApi.getCities((data) => { this.store.Cities = data.Success ? data.Cities : []; })
		ProductApi.getList({ Type: 1, Active: true }, (data) => { this.store.Products = data.Success ? data.Products : []; });
	}

	/** API запрос на получение списка поставщиков от сервера */
	getData = () => {
		this.store.IsSendRequest = false;
		ProviderApi.getList(this.store.Filter.Active, (data) => { this.store.setProviders(data); });
	}

	/**
	 * API запрос на получения поставщика по ID
	 * @param {number} id ID поставщика
	 */
	getItem = (id) => {
		ProviderApi.getById(id, (data) => { this.store.setProvider(data); });
	}

	/**
	 * Уставнока активного поставщика или сброс его
	 * @param {number|undefined} id 
	 */
	setId = (id) => {
		if(_.isUndefined(id)) {
			this.store.setProvider(undefined);
			this.getData();
		} else {
			if (id === -1) this.store.setProvider({ Id : -1 });
			else this.getItem(id);
		}
	}

	/** 
	 * Переключатель фильтра поставщиков 
	 * @param {boolean} value Значение фильтра
	 * @param {string} id Название поля фильтра
	 */
	setFilter = (value, id) => {
		this.store.Filter[id] = value;
		this.getData();
	}

	/**
	 * API запрос на удаление/восстановление поставщика
	 * @param {number} id ID поставщика
	 */
	removeId = (id) => {
		if (_.isUndefined(id)) return false;

		var	item = _.find(this.store.Providers, { Id : id }),
			text = <span>Вы действительно хотите {item.Active ? "удалить" : "восстановить"} 
						&nbsp;поставщика <b key="b1">«{item ? item.Name : ""}»</b>?</span>;

		confirmState.openConfirm(text, () => { ProviderApi.remove(id, () => { this.getData(); }) });
	}

	render() {
		return (
			<div className="page" id="ProvidersPage">
				{_.isUndefined(this.store.Provider) &&
					<>
						<div className="head">
							<h2>Поставщики</h2>
							<div className="filter form">
								<ButtonSelectGroup
									Id="Active"
									List={[
										{ Id : true, Name : "Активные" },
										{ Id : false, Name : "Удалённые", Style : "red" }
									]}
									Value={this.store.Filter.Active}
									RowClass="nomargin"
									onChange={this.setFilter}
								/>
							</div>
							{this.store.CanManage && this.store.Filter.Active &&
								<CreateButton Title="Создать поставщика" onClick={() => this.setId(-1)} />
							}
						</div>
						{this.store.IsSendRequest &&
							<TableReportPage
								Type={this.props.Type}
								TableColumns={this.store.columns}
								TableData={this.store.Providers}
								TableFilterable={true}
								editRow={this.setId}
								removeRow={this.removeId}
								getTrProps={(state, rowInfo, column) => {
									return { className: rowInfo && !rowInfo.original.Active ? "notactive" : "" };
								}}
							/>
						}
					</>
				}
				{!_.isUndefined(this.store.Provider) &&
					<ProviderItem store={this.store}
						Provider={this.store.Provider}
						Cities={this.store.Cities}
						Products={this.store.Products}
						setId={this.setId}
					/>
				}
			</div>
		)
	}
}
ProvidersPage = observer(ProvidersPage);

class ProviderItem extends Component {
	componentDidMount() {
		if (this.props.Provider.Id !== -1) this.getHistory();
	}

	/** API запрос на получение истории поставок поставщика */
	getHistory = () => {
		ProviderApi.getInvoiceHistory(this.props.Provider.Id, (data) => { this.props.Provider.setHistory(data); });
	}

	/** Закрыть окно активного поставщика */
	handleClose = (event) => {
		event.preventDefault();
		this.props.setId(undefined);
	}

	/** API запрос на редактирование поставщика */
	handleSubmit = (event) => {
		event.preventDefault();

		if (!this.props.Provider.validate())
			return false;

		this.props.Provider.ButtonLoading = true;

		ProviderApi.save(this.props.Provider.getData(), (data) => {
			this.props.Provider.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			this.props.Provider.SuccessSave = data.Success;
			this.props.Provider.ButtonLoading = false;
		});
	}

	render() {
		return (
			<section className="item" id="ProviderItem">
				<form onSubmit={this.handleSubmit} >
					<ItemNewHeader
						Title={this.props.Provider.Id === -1 ? "Новый поставщик" : "Редактирование поставщика"}
						ErrorCode={this.props.Provider.ErrorCode}
						ButtonLoading={this.props.Provider.ButtonLoading}
						SuccessSave={this.props.Provider.SuccessSave}
						CanManage={this.props.Provider.CanManage}
						handleClose={this.handleClose}
					/>
					<div className='container'>
						<div>
							<MainInfo Provider={this.props.Provider} Cities={this.props.Cities} />
							<ProductsBlock
								ProviderProducts={this.props.Provider.Products}
								CanManage={this.props.Provider.CanManage}
								CanManageFinance={this.props.Provider.CanManageFinance}
								Products={this.props.Products}
							/>
							{this.props.Provider.CanManageFinance && <FinanceBlock Provider={this.props.Provider} /> }
						</div>
						<div>
							{this.props.Provider.CanManageFinance && this.props.Provider.History &&
								<OrderHistoryBlock History={this.props.Provider.History} />
							}
							<WorkDaysBlock
								Title="Время приема заказов"
								WorkDays={this.props.Provider.WorkHours}
								Disabled={!this.props.Provider.CanManage}
							/>
							<ContactsBlock Contacts={this.props.Provider.Contacts} CanManage={this.props.Provider.CanManage} />
						</div>
					</div>
				</form>
			</section>
		)
	}
}
ProviderItem = observer(ProviderItem);

class MainInfo extends Component {
	render() {
		return (
			<div className="section mainInfo">
				{this.props.Provider.CanManage &&
					<DadataInput
						Title="Заполнить автоматически по ИНН или названию поставщика"
						Type="party"
						RowClass="wide"
						onChange={this.props.Provider.setSuggestProvider}
					/>
				}
				<TextInput
					Id="Name"
					Title="Название поставщика"
					Required={true}
					Value={this.props.Provider.Name}
					Disabled={!this.props.Provider.CanManage}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<Selectize
					Id="CityId"
					Title="Город"
					List={toSelectList(this.props.Cities)}
					Value={this.props.Provider.CityId}
					Required={true}
					Disabled={!this.props.Provider.CanManage}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="DefermentPayment"
					Title="Отсрочка платежа"
					Type="number"
					Value={this.props.Provider.DefermentPayment}
					Disabled={!this.props.Provider.CanManage}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="MinAmount"
					Title="Минимальная сумма заказа"
					Value={this.props.Provider.MinAmount}
					Disabled={!this.props.Provider.CanManage}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="Address"
					RowClass="wide"
					Title="Юридический адрес"
					Value={this.props.Provider.Address}
					Required={true}
					Disabled={!this.props.Provider.CanManage}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="FactAddress"
					RowClass="wide"
					Title="Фактический адрес"
					Value={this.props.Provider.FactAddress}
					Disabled={!this.props.Provider.CanManage}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="Description"
					RowClass="wide"
					Title="Комментарий"
					Type="textarea"
					Disabled={!this.props.Provider.CanManage}
					Value={this.props.Provider.Description}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
			</div>
		)
	}
}
MainInfo = observer(MainInfo);

class OrderHistoryBlock extends Component {
	render() {
		return(
			<div className="section history">
				<div className=''>
					<h4 className="sectionTitle"><PayReceiptIcon />История закупок</h4>
					{this.props.History.List.length > this.props.History.VisibleCount &&
						<ExpandIconButton IsOpen={this.props.History.ShowAll} onClick={this.props.History.toggle} />
					}
				</div>
				<div className='order'>
					{_.map(this.props.History.Items, (item,i) =>  {
						return(<OrderHistoryItem Item={item} key={"oh" + i} />)
					})}
				</div>
			</div>
		)
	}
}
OrderHistoryBlock = observer(OrderHistoryBlock)

class OrderHistoryItem extends Component {
	render() {
		return(
			<>
				<i className={this.props.Item.State}></i>
				<span>{this.props.Item.Date}</span>
				<span>{this.props.Item.Title}</span>
				<span>{this.props.Item.Amount} руб.</span>
			</>
		)
	}
}
OrderHistoryItem = observer(OrderHistoryItem)

class FinanceBlock extends Component {
	render () {
		return(
			<div className="section requisites">
				<h4>Реквизиты поставщика</h4>
				<TextInput
					Id="INN"
					Title="ИНН"
					Mask="999999999999"
					Disabled={!this.props.Provider.CanManage}
					Value={this.props.Provider.INN}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="KPP"
					Title="КПП"
					Mask="999999999"
					Disabled={!this.props.Provider.CanManage}
					Value={this.props.Provider.KPP}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				{this.props.Provider.CanManage &&
					<DadataInput
						Title="Заполнить реквизиты банка по ИНН или Названию"
						Type="bank"
						onChange={this.props.Provider.setSuggestBank}
					/>
				}
				<TextInput
					Id="Bank"
					Title="Банк"
					Disabled={!this.props.Provider.CanManage}
					Value={this.props.Provider.Bank}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="BIK"
					Title="БИК"
					Mask="049999999"
					Disabled={!this.props.Provider.CanManage}
					Value={this.props.Provider.BIK}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="CorrAccount"
					Title="Корр. счет"
					Mask="9999 9999 9999 9999 9999"
					Disabled={!this.props.Provider.CanManage}
					Value={this.props.Provider.CorrAccount}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
				<TextInput
					Id="CheckAccount"
					Title="Рассчетный счет"
					Mask="9999 9999 9999 9999 9999"
					Disabled={!this.props.Provider.CanManage}
					Value={this.props.Provider.CheckAccount}
					onChange={(value, id) => this.props.Provider.collect(id, value)}
				/>
			</div>
		)
	}
}
FinanceBlock = observer(FinanceBlock);

class ContactsBlock extends Component {
	render() {
		return(
			<div className="section contacts">
				<h4 className="sectionTitle"><AddPhoneIcon />Контактные данные</h4>
				{_.map(this.props.Contacts.List, (item,i) => {
					return (<ContactItem
						CanManage={this.props.CanManage}
						handleDelete={this.props.Contacts.removeItem}
						Item={item} Index={i} key={"c" + i} />)
				}) }
				{this.props.CanManage &&
					<AddButton Title="Добавить контактное лицо" onClick={this.props.Contacts.addItem} />
				}
			</div>
		)
	}
}
ContactsBlock = observer(ContactsBlock)

class ContactItem extends Component {
	render() {
		return(
			<div className="contact">
				<TextInput
					Id="FIO"
					Title="Имя контактного лица"
					Value={this.props.Item.FIO}
					Required={true}
					Disabled={!this.props.CanManage}
					onChange={(value,id) => this.props.Item.collect(id, value)}
				/>
				{this.props.CanManage
					? <RemoveIconButton onClick={() => this.props.handleDelete(this.props.Index)} />
					: <span>&nbsp;</span>
				}
				<TextInput
					Id="Phone"
					Title="Телефон"
					Value={this.props.Item.Phone}
					Disabled={!this.props.CanManage}
					onChange={(value,id) => this.props.Item.collect(id, value)}
					Mask="7 (999) 999-99-99"
				/>
				<TextInput
					Id="Email"
					Title="E-mail"
					Value={this.props.Item.Email}
					Disabled={!this.props.CanManage}
					onChange={(value,id) => this.props.Item.collect(id, value)}
				/>
			</div>
		)
	}
}
ContactItem = observer(ContactItem)

class ProductsBlock extends Component {
	render() {
		return(
			<div className="section products">
				<h4>Список товаров для заказа</h4>
				<div className="table">
					<span className='title'>Товар</span>
					<span className='title'>Мин. заказ</span>
					<span className='title'>Цена за ед.</span>
					<span className='title'>НДС</span>
					<span className='title'>&nbsp;</span>
					{_.map(this.props.ProviderProducts.List, (v,i) => {
						return (
							<ProductItem
								Products={this.props.Products}
								CanManage={this.props.CanManage}
								CanManageFinance={this.props.CanManageFinance}
								handleDelete={this.props.ProviderProducts.removeItem}
								Item={v} Index={i} key={"pr" + i}
							/>)
					}) }
				</div>
				{this.props.CanManage &&
					<AddButton Title="Добавить товар" onClick={this.props.ProviderProducts.addItem} />
				}
			</div>
		)
	}
}
ProductsBlock = observer(ProductsBlock)
class ProductItem extends Component {
	handleChange(id, value) {
		var product = _.find(this.props.Products, { Id : value});
		this.props.Item.collect(id, value, product);
	}
	render() {
		return(
			<>
				<Selectize
					Id="ProductId"
					Value={this.props.Item.ProductId}
					List={toSelectList(this.props.Products)}
					Required={true}
					Disabled={!this.props.CanManage}
					onChange={(value,id) => this.handleChange(id, value)}
				/>
				<TextInput
					Id="MinCount"
					Value={this.props.Item.MinCount}
					Disabled={!this.props.CanManage}
					Type="number"
					Step="0.001"
					Icon={this.props.Item.Unit}
					IconType="text"
					onChange={(value,id) => this.props.Item.collect(id, value)}
				/>
				{this.props.CanManageFinance ?
					<TextInput
						Id="Price"
						Value={getRubs(this.props.Item.Price)}
						Disabled={true}
					/> : <span>&nbsp;</span>
				}
				<Selectize
					Id="VAT"
					Value={this.props.Item.VAT}
					List={getVATList(this.props.Item.VAT)}
					Disabled={!this.props.CanManage}
					isClearable={false}
					onChange={(value,id) => this.props.Item.collect(id, value)}
				/>
				{this.props.CanManage
					? <RemoveIconButton onClick={() => this.props.handleDelete(this.props.Index)} />
					: <span>&nbsp;</span>
				}
			</>
		)
	}
}
ProductItem = observer(ProductItem)

export default ProvidersPage;
